import { render, staticRenderFns } from "./DispatchDockets.vue?vue&type=template&id=1ef8611b&"
import script from "./DispatchDockets.vue?vue&type=script&lang=js&"
export * from "./DispatchDockets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports